import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Swal from "sweetalert2";

const ProtectedRoute = ({ allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  const hasRequiredRole = user && allowedRoles?.includes(user.role);

  if (!user) {
    // Not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }

  if (!hasRequiredRole) {
    // Logged in but does not have the required role
    Swal.fire({
      icon: "error",
      title: "Truy cập bị từ chối",
      text: "Bạn không có quyền truy cập vào trang này.",
      timer: 3000,
      showConfirmButton: false,
    });
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
